import * as React from "react";
import { forwardRef } from "react";
const SvgAssistant = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	"data-name": "Layer 2",
	id: "Layer_2",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("defs", { id: "defs1" }, /* @__PURE__ */ React.createElement("style", { id: "style1" }, ".cls-2{fill:#30ba78;stroke:#0c322c;stroke-width:2.01px;stroke-miterlimit:10;}")), /* @__PURE__ */ React.createElement("g", {
	"data-name": "Layer 1",
	id: "Layer_1",
	style: { strokeWidth: 4.84856 },
	transform: "matrix(.216 0 0 .197 .8 1.2)"
}, /* @__PURE__ */ React.createElement("g", {
	id: "g3",
	style: { strokeWidth: 4.84856 }
}, /* @__PURE__ */ React.createElement("g", {
	id: "g4",
	transform: "translate(0 25.2)"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M94.9 9 80.1 1.6v11.1L57.4 1.5H23.6L1 24v22.7l11.3 11.2h11.3l11.2-11.2V35.3h11.3v11.3h11.3V35.3h11.3v11.3H80V35.3h22.5v-14c0-5.3-3-10-7.6-12.3z",
	id: "path1",
	style: {
		stroke: "#0c322c",
		strokeMiterlimit: 10,
		fill: "#35b777",
		strokeWidth: 2.42428,
		strokeDasharray: "none"
	}
}), /* @__PURE__ */ React.createElement("path", {
	className: "cls-2",
	d: "M34.8 35.3c0-6.2-5-11.3-11.2-11.3L12.3 35.3v11.3h11.3V35.3",
	id: "path2",
	style: {
		strokeWidth: 2.42428,
		strokeDasharray: "none"
	}
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 91.2,
	cy: 24,
	id: "circle2",
	r: 5.6,
	style: {
		fill: "#8fd0b7",
		stroke: "#0c322c",
		strokeMiterlimit: 10,
		strokeWidth: 2.42428,
		strokeDasharray: "none"
	}
}), /* @__PURE__ */ React.createElement("circle", {
	className: "cls-2",
	cx: 93.5,
	cy: 26.3,
	id: "circle3",
	r: 2.2,
	style: {
		strokeWidth: 2.42428,
		strokeDasharray: "none"
	}
})))));
const ForwardRef = forwardRef(SvgAssistant);
export default ForwardRef;
